import React, { useState, useEffect, useRef } from "react";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import Typewriter from "typewriter-effect";
import axios from "axios";
// import { MetaTags } from "react-meta-tags";

import AboutUsBanImg from "../../assets/images/about-us-ban.png";

function Aboutus() {
  const [slugButton, setSlugButton] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [targetSection, setTargetSection] = useState("all");
  const [activeLoader, setActiveLoader] = useState(true);
  const [viewMoreButton, setViewMoreButton] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "instant",
    });
  }, []);

  useEffect(() => {
    setActiveLoader(false);
    const imageKey = {
      type: targetSection,
    };
    axios
      .post(`${process.env.REACT_APP_API_ROOT}/aboutus`, imageKey)
      .then(function (response) {
        setOccasions(response.data.data);
        setActiveLoader(true);
      })
      .catch(function (error) {});
  }, [targetSection]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_ROOT}/aboutus-slug`)
      .then(function (response) {
        setSlugButton(response.data.data);
      })
      .catch(function (error) {});
  }, []);

  const PhotoItem = ({ image }) => (
    <LightgalleryItem src={image}>
      <img
        src={image}
        className="animation_image"
        alt=""
        style={{ cursor: "pointer" }}
      />
    </LightgalleryItem>
  );

  const pgFilterRef = useRef(null);

  useEffect(() => {
    const pgFilterDiv = pgFilterRef.current;

    const handleWheel = (event) => {
      if (event.deltaY !== 0) {
        event.preventDefault();
      }

      pgFilterDiv.scrollLeft += event.deltaY;
    };

    pgFilterDiv.addEventListener("wheel", handleWheel);

    return () => {
      pgFilterDiv.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <>
      {/* <MetaTags>
        <meta
          id="meta-description"
          name="description"
          content="Learn about Kindlebit Solutions, a trusted IT company that provides web development, mobile app development, and digital marketing services."
        />
      </MetaTags> */}
      <main className="inner-page" id="aboutus">
        <section className="banner dark">
          <img
            className="banner-img"
            src={AboutUsBanImg}
            alt="./images/career-ban.png"
          />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">About Us</div>
              <div className="text-para">
                Fostering connections is what we do. We are committed to
                building deep relationships between individuals and brands. We
                are
                <Typewriter
                  options={{
                    strings: [
                      "creators.",
                      "professionals.",
                      "visionaries.",
                      "agency.",
                    ],
                    autoStart: true,
                    loop: true,
                  }}
                />
              </div>
            </div>
            {/* <div className="about-us-ban-vid">
              <div className="blurred-art" id="blur-sq"></div>
              <div className="blurred-art" id="blur-circ"></div>
              <svg
                className="back-orange-blur"
                xmlns="http://www.w3.org/2000/svg"
                width="226.216"
                height="226.217"
                viewBox="0 0 226.216 226.217"
              >
                <rect
                  id="Rectangle_86"
                  data-name="Rectangle 86"
                  width="226.216"
                  height="226.217"
                  rx="113.108"
                  fill="#f38020"
                />
              </svg>
              <div className="au-float-caption">
                <div className="sap-style-heading">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="137.314"
                    height="40.724"
                    viewBox="0 0 137.314 40.724"
                  >
                    <path
                      id="Path_438"
                      data-name="Path 438"
                      d="M3.445-.457q-.088-.264-.3-.826L2.672-2.549q-.264-.7-.562-1.494T1.547-5.537L1.072-6.8.756-7.646a1.887,1.887,0,0,1-.185-.36,1.1,1.1,0,0,1-.079-.4.729.729,0,0,1,.088-.36A.5.5,0,0,1,.861-9a.5.5,0,0,1,.343.132.806.806,0,0,1,.22.308L3.445-3.375q.018-.246.088-.888t.141-1.362q.07-.721.132-1.362t.1-.888q.018-.176.035-.4a2.156,2.156,0,0,1,.079-.439,1.011,1.011,0,0,1,.193-.369.464.464,0,0,1,.378-.158.674.674,0,0,1,.255.035A.524.524,0,0,1,5.027-9L8.4-3.234V-9.176a.861.861,0,0,1,.712.255A1.212,1.212,0,0,1,9.36-8.3a3.265,3.265,0,0,1-.009.791,4.32,4.32,0,0,0-.035.756q0,.123.018.527t.044.932q.026.527.044,1.134t.044,1.134q.026.527.044.932t.018.527q.123.352-.009.466a.427.427,0,0,1-.36.079A1.1,1.1,0,0,1,8.7-1.213a.756.756,0,0,1-.3-.352L4.816-7.646q-.123,2.654-.246,4.43T4.342-.229q-.053.193-.176.211a.446.446,0,0,1-.255-.044.906.906,0,0,1-.255-.185ZM16-.457q-.088-.457-.149-1.1t-.132-1.3q-.07-.659-.167-1.239a3.192,3.192,0,0,0-.29-.949,27.589,27.589,0,0,1-1.582,2.874,7.381,7.381,0,0,1-1.2,1.494,1.372,1.372,0,0,1-.87.431.752.752,0,0,1-.58-.316,1.866,1.866,0,0,1-.325-.765,7.5,7.5,0,0,1-.132-.87,4.846,4.846,0,0,1,.176-1.09q.176-.7.475-1.538a17.789,17.789,0,0,1,.712-1.7,12.3,12.3,0,0,1,.888-1.564,6.227,6.227,0,0,1,.984-1.16,1.539,1.539,0,0,1,1.02-.457,1.1,1.1,0,0,1,1.116.325,1.8,1.8,0,0,1,.132,1.5,17.424,17.424,0,0,0,.1,1.986q.1.826.211,1.582t.211,1.582a17.424,17.424,0,0,1,.1,1.986,1.289,1.289,0,0,1-.044.36q-.044.149-.431.149-.053,0-.132-.088A.247.247,0,0,1,16-.457Zm-.949-7.857q-.193-.281-.527-.053a2.978,2.978,0,0,0-.7.756,11.639,11.639,0,0,0-.756,1.266q-.387.738-.721,1.494t-.58,1.433A8.024,8.024,0,0,0,11.434-2.3q0,.633.193.712t.475-.2a5.785,5.785,0,0,0,.642-.809q.36-.527.7-1.125t.65-1.16q.308-.562.483-.914a5.477,5.477,0,0,0,.246-.686q.088-.316.149-.606a3.3,3.3,0,0,0,.07-.589Q15.055-7.98,15.055-8.314ZM18.7-.229Q18.509-2.6,18.36-4.983t-.325-4.948q0-.422.457-.422h.141q.053,0,.123.141a2.435,2.435,0,0,1,.149.519q.079.378.176,1.143t.237,2q.141,1.23.316,3.076a20.972,20.972,0,0,0,.58-2.32,13.141,13.141,0,0,1,.545-2.048,5.143,5.143,0,0,1,.94-1.626,3.557,3.557,0,0,1,1.749-1.037,1.445,1.445,0,0,1,1.02.765,5.89,5.89,0,0,1,.615,1.626,13.769,13.769,0,0,1,.316,2.1q.088,1.134.105,2.171T25.523-2q0,.817.035,1.169A.683.683,0,0,1,25.4-.58a.6.6,0,0,1-.237.149.478.478,0,0,1-.255.018A.389.389,0,0,1,24.679-.6q0-.193-.035-.791t-.088-1.4q-.053-.8-.114-1.705T24.336-6.2q-.044-.8-.079-1.4T24.2-8.385q-.369-.65-.729-.738a.786.786,0,0,0-.721.229,3.266,3.266,0,0,0-.694.967,12.97,12.97,0,0,0-.633,1.468q-.3.817-.562,1.714t-.457,1.731q-.193.835-.325,1.512T19.915-.457a.587.587,0,0,1-.22.237,1.208,1.208,0,0,1-.352.167.878.878,0,0,1-.369.026A.346.346,0,0,1,18.7-.229Zm9.061,0Q27.57-2.6,27.421-4.983T27.1-9.932q0-.422.457-.422h.141q.053,0,.123.141a2.435,2.435,0,0,1,.149.519q.079.378.176,1.143t.237,2q.141,1.23.316,3.076a20.972,20.972,0,0,0,.58-2.32,13.141,13.141,0,0,1,.545-2.048,5.143,5.143,0,0,1,.94-1.626,3.557,3.557,0,0,1,1.749-1.037,1.445,1.445,0,0,1,1.02.765,5.89,5.89,0,0,1,.615,1.626,13.768,13.768,0,0,1,.316,2.1q.088,1.134.105,2.171T34.584-2q0,.817.035,1.169a.683.683,0,0,1-.158.246.6.6,0,0,1-.237.149.478.478,0,0,1-.255.018A.389.389,0,0,1,33.74-.6q0-.193-.035-.791t-.088-1.4q-.053-.8-.114-1.705T33.4-6.2q-.044-.8-.079-1.4t-.053-.791q-.369-.65-.729-.738a.786.786,0,0,0-.721.229,3.266,3.266,0,0,0-.694.967,12.97,12.97,0,0,0-.633,1.468q-.3.817-.562,1.714t-.457,1.731q-.193.835-.325,1.512T28.976-.457a.587.587,0,0,1-.22.237,1.208,1.208,0,0,1-.352.167.878.878,0,0,1-.369.026A.346.346,0,0,1,27.764-.229ZM41.079-.457q-.088-.457-.149-1.1t-.132-1.3q-.07-.659-.167-1.239a3.192,3.192,0,0,0-.29-.949,27.589,27.589,0,0,1-1.582,2.874,7.381,7.381,0,0,1-1.2,1.494,1.372,1.372,0,0,1-.87.431.752.752,0,0,1-.58-.316,1.866,1.866,0,0,1-.325-.765,7.5,7.5,0,0,1-.132-.87,4.846,4.846,0,0,1,.176-1.09q.176-.7.475-1.538a17.789,17.789,0,0,1,.712-1.7A12.3,12.3,0,0,1,37.9-8.086a6.227,6.227,0,0,1,.984-1.16A1.539,1.539,0,0,1,39.9-9.7a1.1,1.1,0,0,1,1.116.325,1.8,1.8,0,0,1,.132,1.5,17.424,17.424,0,0,0,.1,1.986q.1.826.211,1.582t.211,1.582a17.424,17.424,0,0,1,.1,1.986,1.289,1.289,0,0,1-.044.36q-.044.149-.431.149-.053,0-.132-.088A.247.247,0,0,1,41.079-.457Zm-.949-7.857q-.193-.281-.527-.053a2.979,2.979,0,0,0-.7.756,11.639,11.639,0,0,0-.756,1.266q-.387.738-.721,1.494t-.58,1.433A8.024,8.024,0,0,0,36.508-2.3q0,.633.193.712t.475-.2a5.785,5.785,0,0,0,.642-.809q.36-.527.7-1.125t.65-1.16q.308-.562.483-.914a5.477,5.477,0,0,0,.246-.686q.088-.316.149-.606a3.3,3.3,0,0,0,.07-.589Q40.129-7.98,40.129-8.314Zm11.847.809a3.384,3.384,0,0,0-.325.185q-.149.1-.29.176a1.136,1.136,0,0,1-.281.114.643.643,0,0,1-.3,0,.2.2,0,0,1-.176-.132,1.379,1.379,0,0,1-.114-.3A2.227,2.227,0,0,1,50.43-7.8a.906.906,0,0,1,0-.255l1.688-.967.105-4.5q.035-.229.281-.185t.51.114a.418.418,0,0,1,.114.026.958.958,0,0,1,.114.044q-.035.475-.079,1.028t-.079,1.107q-.035.554-.044,1.081a6.794,6.794,0,0,0,.044.949l2.637-.738q.07-.018.114.1t.088.272a2.01,2.01,0,0,1,.062.316L56-9.246,53.014-7.98q0,.158.026.756T53.1-5.81q.035.817.07,1.758t.07,1.749q.035.809.053,1.415t.018.765Q53.277.4,53,.4a.951.951,0,0,1-.589-.264ZM61.688-.457q-.088-.457-.149-1.1t-.132-1.3q-.07-.659-.167-1.239a3.192,3.192,0,0,0-.29-.949,27.589,27.589,0,0,1-1.582,2.874,7.381,7.381,0,0,1-1.2,1.494,1.372,1.372,0,0,1-.87.431.752.752,0,0,1-.58-.316,1.866,1.866,0,0,1-.325-.765,7.5,7.5,0,0,1-.132-.87,4.846,4.846,0,0,1,.176-1.09q.176-.7.475-1.538a17.789,17.789,0,0,1,.712-1.7,12.3,12.3,0,0,1,.888-1.564,6.227,6.227,0,0,1,.984-1.16A1.539,1.539,0,0,1,60.51-9.7a1.1,1.1,0,0,1,1.116.325,1.8,1.8,0,0,1,.132,1.5,17.424,17.424,0,0,0,.1,1.986q.1.826.211,1.582t.211,1.582a17.424,17.424,0,0,1,.1,1.986,1.289,1.289,0,0,1-.044.36q-.044.149-.431.149-.053,0-.132-.088A.247.247,0,0,1,61.688-.457Zm-.949-7.857q-.193-.281-.527-.053a2.979,2.979,0,0,0-.7.756,11.639,11.639,0,0,0-.756,1.266q-.387.738-.721,1.494t-.58,1.433A8.024,8.024,0,0,0,57.118-2.3q0,.633.193.712t.475-.2a5.785,5.785,0,0,0,.642-.809q.36-.527.7-1.125t.65-1.16q.308-.562.483-.914a5.477,5.477,0,0,0,.246-.686q.088-.316.149-.606a3.3,3.3,0,0,0,.07-.589Q60.739-7.98,60.739-8.314ZM64.157-13.5q.369-.352.589-.281t.325.475a4.823,4.823,0,0,1,.123,1.055q.018.65-.009,1.468t-.1,1.723q-.07.905-.123,1.775T64.9-5.625a9.766,9.766,0,0,0,.053,1.371H65a.072.072,0,0,0,.053-.018,14.885,14.885,0,0,0,1.635-1.934q.721-1.02,1.3-1.925T69.018-9.7a3.171,3.171,0,0,1,.835-.914,1.036,1.036,0,0,1,.448.088q.185.088.185.4,0,.035-.009.114t-.009.114q-.439.9-.967,1.8a20.365,20.365,0,0,1-1.143,1.749,16.565,16.565,0,0,1-1.327,1.6,11.751,11.751,0,0,1-1.538,1.371.37.37,0,0,1-.009.062.369.369,0,0,0-.009.062q0,.176.29.387a3.864,3.864,0,0,0,.738.4q.448.193,1,.387t1.09.334q.536.141,1,.229a4.2,4.2,0,0,0,.729.088q0,.07.009.264a1.927,1.927,0,0,1-.026.4,1.246,1.246,0,0,1-.123.378.3.3,0,0,1-.281.167h-.07a.072.072,0,0,1-.053-.018L64.755-2.25a10.158,10.158,0,0,1-.141,1.679,3.463,3.463,0,0,1-.29.949q-.167.308-.352.29T63.648.387Zm8.077,9.7-.264.053a1.282,1.282,0,0,1-.369.018.812.812,0,0,1-.343-.105.318.318,0,0,1-.149-.3.243.243,0,0,1,.053-.176q.053-.053.176-.158A2.714,2.714,0,0,0,72-5.282a10.071,10.071,0,0,0,.5-1.072q.229-.571.483-1.143a5.61,5.61,0,0,1,.589-1.028,2.625,2.625,0,0,1,.826-.738,2.3,2.3,0,0,1,1.213-.264,1.9,1.9,0,0,1,.668.141,2.8,2.8,0,0,1,.686.378,2.13,2.13,0,0,1,.527.571A1.355,1.355,0,0,1,77.7-7.7q.088.141-.167.4a4.818,4.818,0,0,1-.694.571q-.439.308-.993.633t-1.063.606l-.9.492a3.45,3.45,0,0,0-.51.316,1.816,1.816,0,0,0-.141.4q-.053.229-.079.431t-.035.369q-.009.167-.009.255,0,.334-.026.738a3.271,3.271,0,0,0,.035.765,1.107,1.107,0,0,0,.29.6,1.044,1.044,0,0,0,.773.237,2.169,2.169,0,0,0,1.09-.29,4.785,4.785,0,0,0,.949-.712,6.983,6.983,0,0,0,.8-.914q.36-.492.65-.923t.519-.712q.229-.281.387-.281a1.3,1.3,0,0,1,.378.062.272.272,0,0,1,.2.29,1.575,1.575,0,0,1-.255.756,6.7,6.7,0,0,1-.668.932,9.825,9.825,0,0,1-.949.976,10.866,10.866,0,0,1-1.081.861,6.755,6.755,0,0,1-1.072.615A2.321,2.321,0,0,1,74.2.018a1.667,1.667,0,0,1-1.2-.387,2.12,2.12,0,0,1-.571-.967,4.688,4.688,0,0,1-.176-1.239Q72.252-3.234,72.234-3.8Zm3.234-4.746a.993.993,0,0,0-.633.29,3.868,3.868,0,0,0-.624.7,4.672,4.672,0,0,0-.475.844,1.9,1.9,0,0,0-.185.712,2.265,2.265,0,0,0,.765-.2,6.863,6.863,0,0,0,.993-.5,5.65,5.65,0,0,0,.861-.633.911.911,0,0,0,.369-.633.333.333,0,0,0-.123-.264,1.094,1.094,0,0,0-.29-.176,1.782,1.782,0,0,0-.343-.105A1.63,1.63,0,0,0,75.469-8.543ZM93.855-.457q-.088-.457-.149-1.1t-.132-1.3q-.07-.659-.167-1.239a3.192,3.192,0,0,0-.29-.949,27.589,27.589,0,0,1-1.582,2.874,7.381,7.381,0,0,1-1.2,1.494,1.372,1.372,0,0,1-.87.431.752.752,0,0,1-.58-.316,1.866,1.866,0,0,1-.325-.765,7.5,7.5,0,0,1-.132-.87,4.846,4.846,0,0,1,.176-1.09q.176-.7.475-1.538a17.789,17.789,0,0,1,.712-1.7,12.3,12.3,0,0,1,.888-1.564,6.227,6.227,0,0,1,.984-1.16,1.539,1.539,0,0,1,1.02-.457,1.1,1.1,0,0,1,1.116.325,1.8,1.8,0,0,1,.132,1.5,17.424,17.424,0,0,0,.1,1.986q.1.826.211,1.582t.211,1.582a17.424,17.424,0,0,1,.1,1.986,1.289,1.289,0,0,1-.044.36q-.044.149-.431.149-.053,0-.132-.088A.247.247,0,0,1,93.855-.457Zm-.949-7.857q-.193-.281-.527-.053a2.979,2.979,0,0,0-.7.756,11.639,11.639,0,0,0-.756,1.266q-.387.738-.721,1.494t-.58,1.433A8.024,8.024,0,0,0,89.284-2.3q0,.633.193.712t.475-.2a5.785,5.785,0,0,0,.642-.809q.36-.527.7-1.125t.65-1.16q.308-.562.483-.914a5.477,5.477,0,0,0,.246-.686q.088-.316.149-.606a3.3,3.3,0,0,0,.07-.589Q92.905-7.98,92.905-8.314Zm11.847.809a3.384,3.384,0,0,0-.325.185q-.149.1-.29.176a1.136,1.136,0,0,1-.281.114.643.643,0,0,1-.3,0,.2.2,0,0,1-.176-.132,1.379,1.379,0,0,1-.114-.3,2.227,2.227,0,0,1-.062-.334.906.906,0,0,1,0-.255l1.688-.967.105-4.5q.035-.229.281-.185t.51.114a.418.418,0,0,1,.114.026.958.958,0,0,1,.114.044q-.035.475-.079,1.028t-.079,1.107q-.035.554-.044,1.081a6.794,6.794,0,0,0,.044.949l2.637-.738q.07-.018.114.1t.088.272a2.01,2.01,0,0,1,.062.316l.018.158L105.789-7.98q0,.158.026.756t.062,1.415q.035.817.07,1.758t.07,1.749q.035.809.053,1.415t.018.765q-.035.527-.308.527a.951.951,0,0,1-.589-.264Zm4.7,5.1a10.454,10.454,0,0,1-.123-1.573,12.816,12.816,0,0,1,.1-1.556q.1-.791.281-1.644t.431-1.837a.662.662,0,0,1,.105-.36.92.92,0,0,1,.281-.281,1.811,1.811,0,0,1,.369-.185,1.08,1.08,0,0,1,.369-.07,1.118,1.118,0,0,1,.7.246,2.926,2.926,0,0,1,.571.6,4.542,4.542,0,0,1,.439.747q.185.4.308.677a9.739,9.739,0,0,1,.2,1.4,11.075,11.075,0,0,1,.009,1.591,9.078,9.078,0,0,1-.246,1.591,6.054,6.054,0,0,1-.545,1.433,3.493,3.493,0,0,1-.905,1.09,2.653,2.653,0,0,1-1.31.545.731.731,0,0,1-.615-.272,1.758,1.758,0,0,1-.308-.668,3.7,3.7,0,0,1-.105-.8Q109.454-2.145,109.454-2.408Zm.9-.053q0,.176.009.334a2.6,2.6,0,0,0,.035.308q.026.149.07.316t.114.378h.105a1.014,1.014,0,0,0,.721-.281,2.377,2.377,0,0,0,.51-.729,5.573,5.573,0,0,0,.352-1,10.879,10.879,0,0,0,.22-1.09q.079-.536.105-1t.026-.747v-.352q0-.229-.018-.519t-.062-.6a3.047,3.047,0,0,0-.132-.562,1.206,1.206,0,0,0-.229-.413.47.47,0,0,0-.369-.158.748.748,0,0,0-.659.053,1.212,1.212,0,0,0-.439.589,4.449,4.449,0,0,0-.255,1.011,10.935,10.935,0,0,0-.105,1.318q-.018.721-.009,1.529T110.351-2.461Zm8.745.422a2.244,2.244,0,0,1-.343.571,6.449,6.449,0,0,1-.642.721,5.836,5.836,0,0,1-.765.633,1.282,1.282,0,0,1-.694.272,1.08,1.08,0,0,1-.923-.527,4.007,4.007,0,0,1-.554-1.354,11.628,11.628,0,0,1-.264-1.837q-.07-1.011-.088-1.978t-.018-1.758a10.01,10.01,0,0,0-.053-1.2.323.323,0,0,1,.185-.211.932.932,0,0,1,.272-.035.865.865,0,0,1,.255.035.375.375,0,0,1,.2.211q0,.193.009.65t.044,1.028q.035.571.07,1.2t.062,1.187q.026.563.053,1.011t.044.659q.018.123.044.4a5.74,5.74,0,0,0,.088.589,3.27,3.27,0,0,0,.158.554q.1.246.255.264a.842.842,0,0,0,.536-.229,3.469,3.469,0,0,0,.536-.58,6.239,6.239,0,0,0,.492-.773q.229-.422.413-.817a5.541,5.541,0,0,0,.281-.712,3.126,3.126,0,0,0,.114-.457q.035-.3.07-.853t.053-1.187q.018-.633.026-1.2t.009-.861l.967.053q.018,1.424-.018,2.575t-.018,2.162a15.164,15.164,0,0,0,.158,1.96,10.173,10.173,0,0,0,.51,1.969,1.273,1.273,0,0,1-.211.149.537.537,0,0,1-.229.1.6.6,0,0,1-.589-.29,1.961,1.961,0,0,1-.193-.686q-.044-.4-.07-.791A.986.986,0,0,0,119.1-2.039Zm2.874-6.434v-.141a.255.255,0,0,1,.132-.246.644.644,0,0,1,.308-.07,1.257,1.257,0,0,1,.264.026.29.29,0,0,1,.193.2q.053.264.105.729t.123,1.028q.07.563.149,1.187t.158,1.178q.079.554.167.993a3.146,3.146,0,0,0,.193.668,18.819,18.819,0,0,1,.105-2.927,5.457,5.457,0,0,1,.606-2.021,2.414,2.414,0,0,1,1.23-1.09,3.824,3.824,0,0,1,1.96-.132q.545,0,.545.58,0,.229-.3.308a3.627,3.627,0,0,1-.668.105q-.369.026-.721.062a.9.9,0,0,0-.51.176,1.905,1.905,0,0,0-.888,1.09,7.9,7.9,0,0,0-.36,1.74q-.105,1-.149,2.188A20.972,20.972,0,0,1,124.377-.4a.29.29,0,0,1-.141.264.634.634,0,0,1-.343.088.889.889,0,0,1-.387-.088.664.664,0,0,1-.29-.264Zm10.2,7.787q0-.3.114-.387a.492.492,0,0,1,.308-.088.681.681,0,0,1,.51.22.7.7,0,0,1,.211.5.353.353,0,0,1-.185.343.877.877,0,0,1-.413.1.315.315,0,0,1-.2-.079.935.935,0,0,1-.176-.193,1.2,1.2,0,0,1-.123-.22A.507.507,0,0,1,132.173-.686Zm-.932-7.1a2.476,2.476,0,0,1,.343-1.283,6.114,6.114,0,0,1,.835-1.1,12.139,12.139,0,0,1,1.09-1.011,11.4,11.4,0,0,0,1.09-1.02,6.226,6.226,0,0,0,.835-1.116,2.555,2.555,0,0,0,.343-1.31.773.773,0,0,0-.211-.6,1.192,1.192,0,0,0-.527-.272,2.568,2.568,0,0,0-.686-.07q-.369.009-.686.009a2.592,2.592,0,0,0-1.072.229q-.51.229-.976.483t-.923.475a2.129,2.129,0,0,1-.932.22,1.015,1.015,0,0,1-.369-.062q-.158-.062-.158-.413,0-.211.3-.422a4.318,4.318,0,0,1,.765-.413q.466-.2,1.037-.387t1.116-.308q.545-.123.976-.2a3.953,3.953,0,0,1,.659-.079,6.553,6.553,0,0,1,.853.062,3.074,3.074,0,0,1,.844.229,1.7,1.7,0,0,1,.633.475,1.212,1.212,0,0,1,.255.8,3.813,3.813,0,0,1-.457,1.775,9.593,9.593,0,0,1-1.1,1.661,17.781,17.781,0,0,1-1.336,1.459q-.694.677-1.187,1.2a.5.5,0,0,0-.272.325.811.811,0,0,0,.009.457,1.275,1.275,0,0,0,.255.457,1.164,1.164,0,0,0,.475.334,1.344,1.344,0,0,0,.659.07,2.083,2.083,0,0,0,.809-.308l.334.686a2.051,2.051,0,0,1-.861.378,4.923,4.923,0,0,1-.949.1,2.043,2.043,0,0,1-.65-.105,2.094,2.094,0,0,1-.58-.3,1.486,1.486,0,0,1-.422-.475A1.268,1.268,0,0,1,131.241-7.787Z"
                      transform="matrix(0.985, -0.174, 0.174, 0.985, 2.485, 40.035)"
                      fill="#1c447d"
                      stroke="#1c447d"
                      strokeWidth="0.2"
                    />
                  </svg>
                </div>
                <div className="au-float-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34.378"
                    height="23.196"
                    viewBox="0 0 34.378 23.196"
                  >
                    <path
                      id="Path_1"
                      data-name="Path 1"
                      d="M29.516,7.149c-.547-.8-1.015-1.488-1.493-2.173A11.461,11.461,0,0,0,21.44.274a6.115,6.115,0,0,0-5.579.973c-1.653,1.26-3.2,2.659-4.784,4.01-.792.675-1.521,1.43-2.346,2.06a3.016,3.016,0,0,1-4.048.154A7.891,7.891,0,0,1,1.153,1.849C-.016,2.036-.1,2.956.066,3.744A8.8,8.8,0,0,0,1.18,6.626,10.618,10.618,0,0,0,3.487,9.2a4.819,4.819,0,0,0,6.566.1c1.322-.983,2.479-2.185,3.733-3.262,1.161-1,2.333-1.985,3.537-2.928a3.749,3.749,0,0,1,3.132-.672,8.114,8.114,0,0,1,4.459,2.389,9.789,9.789,0,0,1,.725.83c1,1.288,1.987,2.584,3.07,4-2.433-.62-4.7-1.2-6.97-1.761-.048-.012-.146.177-.272.338.137.162.248.409.435.5,2.154,1.021,4.278,2.124,6.494,2.987,1.7.662,2.741.131,3.218-1.638a23.219,23.219,0,0,0,.616-4.711,1.6,1.6,0,0,0-.893-1.158c-.244-.1-.92.343-1.113.7A12.259,12.259,0,0,0,29.516,7.149Z"
                      transform="translate(29.885 23.196) rotate(-158)"
                      fill="#1c447d"
                    />
                  </svg>
                </div>
              </div>
              <div className="au-ban-pop-backdrop">
                <img
                  src="/assets/images/ab-vid-thumb.png"
                  alt="./images/career-ban.png"
                />
              </div>
              <button
                className="au-ban-pop"
                data-bs-toggle="modal"
                data-bs-target="#au-ban-pop"
              >
                <img
                  src="/assets/images/ab-vid-thumb.png"
                  alt="./images/career-ban.png"
                />
                <span className="play-btn">
                  <svg viewBox="0 0 65 65" xmlns="http://www.w3.org/2000/svg">
                    <g
                      transform="translate(-385 -4473)"
                      fill="none"
                      data-name="Group 40"
                    >
                      <g
                        transform="translate(385 4473)"
                        stroke="#fff"
                        strokeWidth="2"
                        data-name="Ellipse 3"
                      >
                        <circle cx="32.5" cy="32.5" r="32.5" stroke="none" />
                        <circle cx="32.5" cy="32.5" r="31.5" fill="none" />
                      </g>
                      <g
                        transform="translate(434.13 4491.1) rotate(90)"
                        data-name="Polygon 1"
                      >
                        <path d="M11.295,5.828a4,4,0,0,1,6.887,0l7.729,13.079a4,4,0,0,1-3.444,6.035H7.01a4,4,0,0,1-3.444-6.035Z" />
                        <path
                          d="m14.738 5.8627c-0.34315 0-1.1978 0.095741-1.7219 0.98254l-7.7285 13.079c-0.53329 0.90249-0.1883 1.7054-0.015228 2.0087 0.17308 0.30331 0.68881 1.0088 1.7371 1.0088h15.457c1.0483 0 1.564-0.70546 1.7371-1.0088 0.17307-0.30331 0.51806-1.1062-0.015232-2.0087l-7.7285-13.079c-0.52402-0.8868-1.3787-0.98254-1.7219-0.98254m0-2c1.3348 0 2.6696 0.65503 3.4437 1.9651l7.7285 13.079c1.5756 2.6665-0.34651 6.0349-3.4437 6.0349h-15.457c-3.0972 0-5.0194-3.3685-3.4437-6.0349l7.7285-13.079c0.77413-1.3101 2.1089-1.9651 3.4437-1.9651z"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </button>
            </div> */}
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>
          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="sap-card-inner container">
            <div className="wwa-head">
              <div className="wwa-img-back"></div>
              <div className="wwa-img">
                <img
                  src="/assets/images/ab-back.png"
                  alt="./images/career-ban.png"
                />
                <span className="au-logo">
                  <img
                    src="/assets/images/logo-dark.svg"
                    alt="./images/career-ban.png"
                  />
                </span>
              </div>
              <div className="wwa-con">
                <div className="sec-heading">
                  <div className="sap-caption-head">
                    <div className="sap-caption">company's insight</div>
                  </div>
                  <div className="sap-lg-heading">Who we are.</div>
                </div>
                <div className="text-para">
                  Since our foundation, KBS has been a thought leader at the
                  nexus of transformational technology and business innovation.
                  We're not simply another agency. We work as a team with you to
                  comprehend your goals, contribute original thinking, and
                  strategize how to make your project successful. The managed
                  teams and prebuilt consulting engagements that our worldwide
                  team of consultants participates in produce clear
                  deliverables, demonstrable change, and knowledge sharing.
                  Instead of creating dependency, we build relationships with
                  our clients. With agility at core, we concentrate on and work
                  effectively towards making your solutions a reality.
                </div>
                <div className="wwa-affi-icons">
                  <ul>
                    <li>
                      <span className="wwa-affi-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18.755"
                          height="25"
                          viewBox="0 0 18.755 25"
                        >
                          <path
                            id="Path_436"
                            data-name="Path 436"
                            d="M8.437.292a1.611,1.611,0,0,1,1.777,0l.869.571a1.629,1.629,0,0,0,.981.264l1.04-.063a1.613,1.613,0,0,1,1.538.889l.469.933a1.62,1.62,0,0,0,.718.718l.942.474a1.613,1.613,0,0,1,.889,1.538L17.6,6.654a1.62,1.62,0,0,0,.264.981l.576.869a1.611,1.611,0,0,1,0,1.777l-.576.874a1.629,1.629,0,0,0-.264.981l.063,1.04a1.612,1.612,0,0,1-.889,1.538l-.933.469a1.62,1.62,0,0,0-.718.718l-.474.942a1.612,1.612,0,0,1-1.538.889l-1.04-.063a1.62,1.62,0,0,0-.981.264l-.869.576a1.611,1.611,0,0,1-1.777,0l-.874-.576a1.629,1.629,0,0,0-.981-.264l-1.04.063a1.612,1.612,0,0,1-1.538-.889l-.469-.933a1.62,1.62,0,0,0-.718-.718l-.942-.474a1.612,1.612,0,0,1-.889-1.538l.063-1.04a1.62,1.62,0,0,0-.264-.981l-.571-.874a1.611,1.611,0,0,1,0-1.777L.791,7.64a1.629,1.629,0,0,0,.264-.981L.991,5.619a1.612,1.612,0,0,1,.889-1.538l.933-.469a1.652,1.652,0,0,0,.723-.727L4,1.952a1.612,1.612,0,0,1,1.538-.889l1.04.063A1.62,1.62,0,0,0,7.563.864ZM13.231,9.4A3.906,3.906,0,1,0,9.325,13.3,3.9,3.9,0,0,0,13.231,9.4ZM.014,21.595l2.1-5a.038.038,0,0,1,.02.02l.469.933A3.184,3.184,0,0,0,5.634,19.29l1.04-.063a.046.046,0,0,1,.034.01l.869.576a3.318,3.318,0,0,0,.786.376l-1.836,4.36a.78.78,0,0,1-1.372.122L3.583,22.264l-2.739.405a.8.8,0,0,1-.732-.293.777.777,0,0,1-.1-.781Zm12.109,2.949-1.836-4.355a3.139,3.139,0,0,0,.786-.376l.869-.576a.071.071,0,0,1,.034-.01l1.04.063a3.184,3.184,0,0,0,3.027-1.748l.469-.933a.038.038,0,0,1,.02-.02l2.109,5a.791.791,0,0,1-.1.781.771.771,0,0,1-.732.293l-2.739-.405-1.572,2.4a.78.78,0,0,1-1.372-.122Z"
                            transform="translate(0.052 -0.025)"
                            fill="#9cb5d4"
                          />
                        </svg>
                      </span>
                      <span className="wwa-affi-text">ISO 9001:2008</span>
                    </li>
                    <li>
                      <span className="wwa-affi-icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24.597"
                          height="25"
                          viewBox="0 0 24.597 25"
                        >
                          <path
                            id="Path_435"
                            data-name="Path 435"
                            d="M24.6,20.792C24.6,27.924,19.713,33,12.5,33a12.5,12.5,0,1,1,0-25,12.021,12.021,0,0,1,8.382,3.271l-3.4,3.271C13.029,10.248,4.753,13.474,4.753,20.5A7.83,7.83,0,0,0,12.5,28.393c4.95,0,6.8-3.548,7.1-5.388H12.5v-4.3H24.4a10.958,10.958,0,0,1,.2,2.087Z"
                            transform="translate(0 -8)"
                            fill="#9cb5d4"
                          />
                        </svg>
                      </span>
                      <span className="wwa-affi-text">Google Partner</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="om-ov-head">
              <div className="om">
                <div className="om-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="70.021"
                    height="70"
                    viewBox="0 0 70.021 70"
                  >
                    <g
                      id="Group_181"
                      data-name="Group 181"
                      transform="translate(-7366.865 -4222.854)"
                    >
                      <path
                        id="Path_213"
                        data-name="Path 213"
                        d="M7534.3,4441.481a.717.717,0,0,1-.493-.234,2.165,2.165,0,0,1-.33-.43q-4.4-7.138-8.8-14.29a1.315,1.315,0,0,1-.241-.973.689.689,0,0,1,.363-.425.785.785,0,0,1,.372-.1c.38,0,.677.384.82.612q1.033,1.656,2.051,3.321l.9,1.458,5.852,9.5a1.8,1.8,0,0,1,.312.655c-.013.526-.193.707-.479.832A.826.826,0,0,1,7534.3,4441.481Z"
                        transform="translate(-120.167 -154.198)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_214"
                        data-name="Path 214"
                        d="M7511.859,4407.284a.788.788,0,0,1-.554-.256.777.777,0,0,1-.234-.553.845.845,0,0,1,.788-.768.788.788,0,0,1,.007,1.576Z"
                        transform="translate(-109.987 -139.465)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_215"
                        data-name="Path 215"
                        d="M7367.328,4292.854a.661.661,0,0,1-.463-.463v-.592l3.873-6.671q3.032-5.221,6.061-10.441,2.438-4.2,4.872-8.405l2.6-4.493c.3-.512.628-.806.907-.806s.61.286.918.784q1.71,2.769,3.417,5.541l1.893,3.071.454-.165a1.251,1.251,0,0,0,.7-.687c.016-.032.031-.064.049-.093q1.868-3.026,3.734-6.057,2.171-3.524,4.346-7.047a2.591,2.591,0,0,0,.4-1.416q-.012-12.814-.007-25.627v-5.022c0-1.276.134-1.408,1.434-1.408h10.6q5.3,0,10.6,0h.04a1.186,1.186,0,0,1,.938.259c.131.137.479.5-.1,1.225l-.688.868c-1.174,1.479-2.387,3.009-3.61,4.482a1.259,1.259,0,0,0,.006,1.839c.9,1.091,1.8,2.218,2.668,3.308q.773.97,1.552,1.939c.455.562.457.83.3,1.128-.146.283-.369.456-1.034.456-2.558,0-5.1,0-7.639,0-4,0-8.127,0-12.191-.015h0a1.123,1.123,0,0,0-1.3,1.31c.02,4.184.017,8.441.014,12.559v2.727a2.206,2.206,0,0,0,.291,1.233q3.15,5.093,6.287,10.194l2.085,3.384c.037.061.081.121.128.184l.052.071.293.414.455-.225a1.362,1.362,0,0,0,.609-.66c.018-.036.036-.071.056-.1q1.411-2.282,2.813-4.562.959-1.559,1.92-3.117c.3-.484.632-.762.915-.762s.6.276.879.758l1.736,3q7.679,13.262,15.356,26.524c.493.85.483,1.083-.229,1.589Zm49.681-27c-1.2,1.95-2.33,3.792-3.505,5.656a1.515,1.515,0,0,0-.007,1.79c2.381,3.838,4.787,7.748,7.114,11.529l2.459,3.994c.118.19.227.41.342.643a3.345,3.345,0,0,0,1.246,1.608,2.582,2.582,0,0,0,1.264.267c.272,0,.547-.022.814-.042s.493-.039.715-.039l3.112,0h4.14l-.516-.89c-4.7-8.116-9.354-16.152-14.03-24.228l-1.612-2.785Zm-43.019,25.406c1.489,0,2.957,0,4.424.011a1.3,1.3,0,0,0,1.2-.713c4.1-6.672,7.506-12.207,10.728-17.42a1.237,1.237,0,0,0,.02-1.428c-1.138-1.822-2.241-3.616-3.41-5.514l-1.747-2.837-16.157,27.9Zm27.378-33c-4.739,7.7-9.446,15.347-14.157,23l-6.125,9.949h41.575l-20.789-33.77Zm2.385-33.816a1,1,0,0,0-1.088,1.162c.011,3,.021,6.492-.007,9.934a1.247,1.247,0,0,0,.294.938,1.233,1.233,0,0,0,.926.3c3.554-.014,7.082-.016,10.066-.016h8.517l-4.212-5.268c-.642-.8-.642-.969,0-1.77l4.123-5.158-1.243-.1c-.121-.01-.2-.015-.269-.015h-6.792c-3.062,0-6.681,0-10.31-.016Zm10.384,62.845a.715.715,0,0,1-.493-.234,2.168,2.168,0,0,1-.33-.43q-4.4-7.138-8.8-14.29a1.556,1.556,0,0,1-.265-.784.66.66,0,0,1,.387-.614.785.785,0,0,1,.372-.1c.381,0,.677.384.82.612q1.033,1.655,2.051,3.32l.9,1.459s4.447,7.218,5.819,9.448l.033.053a1.876,1.876,0,0,1,.312.648c-.013.532-.193.713-.479.838A.824.824,0,0,1,7414.137,4287.283Zm-12.266-19.463a.787.787,0,1,1,.007,0Z"
                        fill="#00224b"
                      />
                    </g>
                  </svg>
                </div>
                <div className="sap-sm-heading">Our Ethos</div>
                <div className="text-para">
                  <p>
                    KBS blends the synergy of an agency with the autonomy of an
                    individual. We join forces, work closely together, and put
                    our hearts and souls into our work because we want to
                    provide our clients with the greatest service possible. The
                    results speak for themselves. We wish to be viewed as an
                    extension of the brand's team rather than just a vendor. To
                    make the brand's success personal, we want to live, breathe,
                    and be the brand we work with.
                  </p>
                </div>
              </div>
              <div className="ov">
                <div className="ov-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="70"
                    height="65.322"
                    viewBox="0 0 70 65.322"
                  >
                    <g
                      id="Group_182"
                      data-name="Group 182"
                      transform="translate(-6912.056 -4202.822)"
                    >
                      <path
                        id="Path_206"
                        data-name="Path 206"
                        d="M6914.4,4348.487c-.552,0-1.115-.018-1.6-.035-.234-.008-.485-.09-.744-.606v-.411a1.151,1.151,0,0,1,1.121-.568q.088,0,.18.006c.227.015.469.021.765.021.177,0,.354,0,.531,0s.345,0,.516,0c.143,0,.285,0,.427.006.524.017.836.286.856.736a.725.725,0,0,1-.733.817C6915.317,4348.474,6914.885,4348.487,6914.4,4348.487Z"
                        transform="translate(0 -109.866)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_207"
                        data-name="Path 207"
                        d="M6971.154,4332.925a2.651,2.651,0,0,1-1.4-.43,4.07,4.07,0,0,1-.842-.772l-4.6-5.161q-9.861-11.07-19.716-22.14a2.725,2.725,0,0,1-.274-3.826q1.161-1.788,2.327-3.573c1.634-2.507,3.324-5.1,4.966-7.664a3.176,3.176,0,0,1,2.93-1.6h.033c2.164.012,4.534.018,7.458.018l4.58,0,4.581,0,4.513,0q2.257,0,4.515,0c2.953,0,5.342-.007,7.519-.021h.033a3.231,3.231,0,0,1,2.99,1.624c1.6,2.509,3.25,5.048,4.845,7.5q1.2,1.843,2.391,3.688a2.742,2.742,0,0,1-.285,3.881q-12.156,13.655-24.321,27.3A3.064,3.064,0,0,1,6971.154,4332.925Zm-1.827-3.135-.327-2.011c-.017-.1-.028-.185-.037-.25a2.245,2.245,0,0,0-.06-.319l-1.881-6.109c-1.7-5.508-3.451-11.2-5.165-16.81a1.189,1.189,0,0,0-1.29-.9h-.028q-3.193.008-6.39.006h-8.335Zm-5.856-25.627c1.6,5.2,3.194,10.369,4.8,15.564l2.711,8.8.677-1.2c.037-.066.064-.112.084-.146a.96.96,0,0,0,.118-.254c.662-2.147,1.328-4.312,1.994-6.476,1.587-5.158,3.229-10.492,4.855-15.734a1.08,1.08,0,0,0-.06-.984,1.05,1.05,0,0,0-.905-.341h-.03q-2.671.011-5.344.008h-9.134Zm18.2-.777a1.125,1.125,0,0,0-1.18.89q-3.32,10.822-6.651,21.639l-.658,2.138.467.219c.046.021.095.042.14.061l.386.155,21.468-24.1.88-.988H6988.9c-2.428,0-4.828,0-7.227-.011Zm-10.5-12.587a1.081,1.081,0,0,0-.852.618c-1.274,2-2.583,4.022-3.85,5.979q-.968,1.5-1.936,3c-.008.012-.021.026-.033.041a.929.929,0,0,0-.2,1l.152.366h14.2l-.542-.9-.117-.2c-.072-.122-.129-.217-.19-.31l-1.6-2.478c-1.375-2.125-2.8-4.323-4.183-6.493A1.082,1.082,0,0,0,6971.169,4290.8Zm17.6-.015c-2.188,3.385-4.332,6.7-6.513,10.079l-.59.915h15.209l-3.339-5.164-3.771-5.83-.5-.771Zm-43.3,10.972H6960.7l-7.6-11.743Zm34.712-.638.5-.771c2.167-3.352,4.305-6.657,6.488-10.028l.593-.916H6972.6Zm-18.013-.024,7.555-11.692h-15.12Z"
                        transform="translate(-24.11 -64.781)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_208"
                        data-name="Path 208"
                        d="M7057.1,4213.455c-.743,0-.8-.818-.806-1.068-.013-3.12-.013-5.914,0-8.543,0-.639.3-1.021.8-1.021h.023c.5.012.758.356.763,1.025.008,1.006.006,2.013,0,3.021l0,1.284,0,1.269c0,.989,0,1.979,0,2.968,0,.321-.082,1.067-.78,1.067Z"
                        transform="translate(-110.003)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_209"
                        data-name="Path 209"
                        d="M7139.543,4251.223a.727.727,0,0,1-.518-.238.857.857,0,0,1,.136-1.259c1.584-1.614,3.161-3.177,4.356-4.358a.985.985,0,0,1,.661-.344.8.8,0,0,1,.357.1.741.741,0,0,1,.447.665,1.016,1.016,0,0,1-.339.714l-.311.313c-1.322,1.332-2.689,2.709-4.05,4.044A1.1,1.1,0,0,1,7139.543,4251.223Z"
                        transform="translate(-172.933 -32.187)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_210"
                        data-name="Path 210"
                        d="M6959.949,4251.182a1.123,1.123,0,0,1-.749-.38c-1.153-1.135-2.315-2.3-3.439-3.431l-.923-.926a.8.8,0,0,1-.264-.98.7.7,0,0,1,.7-.466h.094a.879.879,0,0,1,.6.331l.5.5c1.269,1.263,2.581,2.568,3.858,3.864.422.428.475.921.136,1.256A.724.724,0,0,1,6959.949,4251.182Z"
                        transform="translate(-32.373 -32.168)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_211"
                        data-name="Path 211"
                        d="M7189.705,4348.509a2.05,2.05,0,0,1-.479-.048c-.633-.151-.684-.541-.667-.82a.72.72,0,0,1,.743-.71c.472-.018.956-.027,1.438-.027s.952.009,1.431.026a.775.775,0,0,1,.774.751.761.761,0,0,1-.689.771,3.855,3.855,0,0,1-.524.03c-.158,0-.315,0-.473-.011s-.342-.011-.512-.011-.356.014-.53.025S7189.868,4348.509,7189.705,4348.509Z"
                        transform="translate(-210.89 -109.893)"
                        fill="#00224b"
                      />
                      <path
                        id="Path_212"
                        data-name="Path 212"
                        d="M7057.173,4262.407a.857.857,0,0,1-.792-.785.757.757,0,0,1,.229-.535.8.8,0,0,1,.566-.253.783.783,0,0,1,.771.789.817.817,0,0,1-.772.785Z"
                        transform="translate(-110.078 -44.247)"
                        fill="#00224b"
                      />
                    </g>
                  </svg>
                </div>
                <div className="sap-sm-heading">Our Values</div>
                <div className="text-para">
                  <p>
                    We adhere to the proactive customer-first philosophy. Our
                    values, we believe, serve as our compass while making
                    decisions and defining what truly constitutes organisational
                    success. Underscoring our dedication to ourselves, our work,
                    and our clients, our principles of embracing the
                    inconceivable, carrying our craft sincerely, and honouring
                    our commitments give direction to all we do.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="au-gal-head">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div className="au-gal-head-inner container">
            <div className="sec-dual-heading">
              <div className="sec-heading">
                <div className="sap-caption-head">
                  <div className="sap-caption">fun starts from here</div>
                </div>
                <div className="sap-lg-heading">
                  Life at Kindle<span className="orange-text">Bit</span>
                </div>
              </div>
              <div className="text-para">
                We recognize the importance of fostering a positive work culture
                and encourage socializing among our employees. This includes
                team-building activities, such as company outings, holiday
                parties (Christmas, Diwali, Holi), Women's Day Celebration, and
                many more.
              </div>
            </div>
            <div className="portfolio-gallery portfolio-gallery-cloned-about-us">
              <div className="pg-filter" ref={pgFilterRef}>
                <button
                  type="button"
                  onClick={() => {
                    setTargetSection("all");
                    setViewMoreButton(false);
                  }}
                  className={`${
                    targetSection === "all" ? `active_button` : `default_button`
                  }`}
                >
                  All
                </button>
                {slugButton &&
                  slugButton.map((butt, index) => {
                    return (
                      <button
                        key={index}
                        type="button"
                        onClick={() => {
                          setTargetSection(butt.slug);
                          setViewMoreButton(false);
                        }}
                        className={`${
                          targetSection === butt.slug
                            ? `active_button`
                            : `default_button`
                        }`}
                      >
                        {butt.title}
                      </button>
                    );
                  })}
              </div>
              <div className="nak-gallery nlg1" id="gallery">
                <div className={`gallery-inner row`}>
                  {activeLoader ? (
                    <>
                      {!viewMoreButton ? (
                        <LightgalleryProvider>
                          {occasions.length > 0 ? (
                            occasions?.map((img, index) => {
                              return (
                                <PhotoItem
                                  key={index}
                                  image={`${process.env.REACT_APP_IMAGE_URL}${img}`}
                                />
                              );
                            })
                          ) : (
                            <p>There is no image.</p>
                          )}
                        </LightgalleryProvider>
                      ) : (
                        <LightgalleryProvider>
                          {occasions.length > 0 ? (
                            occasions?.map((img, index) => {
                              return (
                                <PhotoItem
                                  key={index}
                                  image={`${process.env.REACT_APP_IMAGE_URL}${img}`}
                                />
                              );
                            })
                          ) : (
                            <p>There is no image.</p>
                          )}
                        </LightgalleryProvider>
                      )}
                    </>
                  ) : (
                    <div className="loader-inner">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="200.002"
                        height="200"
                        viewBox="0 0 200.002 200"
                      >
                        <defs>
                          <clipPath id="clipPath">
                            <path
                              id="Path_658"
                              data-name="Path 658"
                              d="M1230.413,405.951a17.241,17.241,0,0,1-24.381,0l-82.76-82.761a17.24,17.24,0,0,1,0-24.38l82.76-82.761a17.248,17.248,0,0,1,24.387,0l82.754,82.761a17.233,17.233,0,0,1,0,24.38Z"
                              fill="none"
                            />
                          </clipPath>
                        </defs>
                        <g
                          id="Group_333"
                          data-name="Group 333"
                          transform="translate(-1118.223 -211)"
                        >
                          <g id="Group_332" data-name="Group 332">
                            <g
                              id="Group_331"
                              data-name="Group 331"
                              clipPath="url(#clipPath)"
                            >
                              <image
                                id="Rectangle_207"
                                data-name="Rectangle 207"
                                width="201"
                                height="200"
                                transform="translate(1118 211)"
                                xlinkHref="data:image/png;base64,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"
                              />
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
export default Aboutus;
